import api from "@/services/api";
import { AssociateType } from "@/types/associate/Associate";

class GetAssociates {
  execute = async (franchiseId: string) => {
    const response = await api().get(`/associates?franchiseId=${franchiseId}`);
    return response.data.associates as AssociateType[];
  };
}

export { GetAssociates };




